module.exports = __webpack_public_path__ + "img/privacy-left.94766b02.svg";